import { Button, type ButtonVariant } from "@design";
import { Play } from "lucide-react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import type { FlowResponse } from "@/api";
import { RunFlowDialog } from "./RunFlowDialog";

/** "Run" for a workflow: opens the run dialog. Anyone who can see a workflow can run it. */
export function RunFlowButton({
  flow,
  variant = "primary",
  runPath,
}: Readonly<{
  flow: FlowResponse;
  variant?: ButtonVariant;
  runPath?: (flowUuid: string, runUuid: string) => string;
}>) {
  const { t } = useTranslation("workflows");
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const noSteps = (flow.steps ?? []).length === 0;
  return (
    <>
      <Button
        variant={variant}
        size="sm"
        leadingIcon={<Play size={14} aria-hidden />}
        disabled={noSteps}
        title={noSteps ? t("runDialog.noSteps") : undefined}
        onClick={() => setOpen(true)}
      >
        {t("runs.run")}
      </Button>
      {open && <RunFlowDialog flow={flow} open onClose={close} runPath={runPath} />}
    </>
  );
}
